import loadable from '@loadable/component';

const Refresh = loadable(() => import('./Refresh'));

export default Refresh;
